import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "copy" }, [
      _createElementVNode("div", { class: "text" }, [
        _createTextVNode(" 版权所有©广州市捍御者信息科技有限公司 "),
        _createElementVNode("a", {
          href: "https://beian.miit.gov.cn",
          target: "_blank"
        }, "粤ICP备17093070号")
      ])
    ], -1)
  ]))]))
}